import React, { Component } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import Button from '../../common/form/button';
import SPButton from '../../common/form/spButton';

class OrdemServicoMateriais extends Component {
  constructor(props) {
    super(props);
    this.state = {
      materiais: [],
      estoqueItens: [],
      estoqueItemId: '',
      quantidade: '',
      observacao: '',
      loading: false,
      devolvendoId: null,
      qtdDevolver: {},
    };
    this.carregar = this.carregar.bind(this);
    this.adicionar = this.adicionar.bind(this);
    this.remover = this.remover.bind(this);
    this.devolverParcial = this.devolverParcial.bind(this);
    this.alterarQtdDevolver = this.alterarQtdDevolver.bind(this);
  }

  alterarQtdDevolver(materialId, valor) {
    this.setState(prev => ({
      qtdDevolver: { ...prev.qtdDevolver, [materialId]: valor },
    }));
  }

  componentDidMount() {
    this.carregar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.osId !== this.props.osId) {
      this.carregar();
    }
  }

  carregar() {
    const { osId } = this.props;
    if (!osId) return;

    this.setState({ loading: true });
    Promise.all([
      axiosInstance.get(`/manutencao/ordens_servico/${osId}/materiais`),
      axiosInstance.get('/manutencao/opcoes'),
    ])
      .then(([materiaisResp, opcoesResp]) => {
        this.setState({
          materiais: materiaisResp.data || [],
          estoqueItens: (opcoesResp.data && opcoesResp.data.estoque_itens) || [],
          loading: false,
        });
      })
      .catch(() => {
        toastr.error('Erro', 'Não foi possível carregar os materiais da OS.');
        this.setState({ loading: false });
      });
  }

  adicionar() {
    const { osId } = this.props;
    const { estoqueItemId, quantidade, observacao } = this.state;

    if (!estoqueItemId) {
      toastr.warning('Atenção', 'Selecione um item de estoque.');
      return;
    }
    if (!quantidade || parseFloat(quantidade) <= 0) {
      toastr.warning('Atenção', 'Informe uma quantidade válida.');
      return;
    }

    axiosInstance
      .post(`/manutencao/ordens_servico/${osId}/materiais`, {
        estoque_item_id: parseInt(estoqueItemId, 10),
        quantidade: parseFloat(quantidade),
        observacao: observacao || null,
      })
      .then(() => {
        toastr.success('Sucesso', 'Material aplicado na OS.');
        this.setState({ estoqueItemId: '', quantidade: '', observacao: '' });
        this.carregar();
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível aplicar o material.');
      });
  }

  devolverParcial(material) {
    const { osId } = this.props;
    const qtd = parseFloat(this.state.qtdDevolver[material.id]);

    if (!qtd || qtd <= 0) {
      toastr.warning('Atenção', 'Informe uma quantidade válida para devolução.');
      return;
    }

    const qtdRestante = parseFloat(material.quantidade) - parseFloat(material.quantidade_devolvida || 0);
    if (qtd > qtdRestante) {
      toastr.warning('Atenção', `Máximo para devolução: ${qtdRestante} ${material.item_unidade}.`);
      return;
    }

    this.setState({ devolvendoId: material.id });
    axiosInstance
      .post(`/manutencao/ordens_servico/${osId}/materiais/${material.id}/devolver`, {
        quantidade: qtd,
      })
      .then(() => {
        toastr.success('Sucesso', 'Devolução registrada no estoque.');
        this.setState(prev => ({
          devolvendoId: null,
          qtdDevolver: { ...prev.qtdDevolver, [material.id]: '' },
        }));
        this.carregar();
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível registrar a devolução.');
        this.setState({ devolvendoId: null });
      });
  }

  remover(material) {
    const { osId } = this.props;
    axiosInstance
      .delete(`/manutencao/ordens_servico/${osId}/materiais/${material.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Material removido e devolvido ao estoque.');
        this.carregar();
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível remover o material.');
      });
  }

  render() {
    const { osNumero } = this.props;
    const {
      materiais,
      estoqueItens,
      estoqueItemId,
      quantidade,
      observacao,
      loading,
      devolvendoId,
      qtdDevolver,
    } = this.state;
    const itemSelecionado = estoqueItens.find(i => String(i.id) === String(estoqueItemId));

    if (!this.props.osId) {
      return (
        <p style={{ color: '#718096', marginTop: 20 }}>
          Selecione uma OS na listagem (Alterar ou Materiais) para gerenciar materiais.
        </p>
      );
    }

    const estoqueDisponivel = itemSelecionado ? `${itemSelecionado.quantidade_atual} ${itemSelecionado.unidade}` : '—';

    return (
      <div className="simple-cad-form-premium os-materiais-premium" style={{ marginTop: 20 }}>
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-boxes" /> Materiais — {osNumero}
              </h4>
              <p>Aplique itens do estoque nesta ordem de serviço. A saída é registrada automaticamente.</p>
            </div>
            <div className="simple-cad-premium-body">
              <div className="os-materiais-composer">
                <div className="form-group form-group-sm os-materiais-field os-materiais-field--item">
                  <label className="label-gt">Item de estoque</label>
                  <select
                    className="form-control"
                    value={estoqueItemId}
                    onChange={e => this.setState({ estoqueItemId: e.target.value })}
                  >
                    <option value="">Selecione...</option>
                    {estoqueItens.map(item => (
                      <option key={item.id} value={item.id}>
                        {item.descricao}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group form-group-sm os-materiais-field os-materiais-field--estoque">
                  <label className="label-gt">Estoque</label>
                  <input type="text" className="form-control" readOnly tabIndex={-1} value={estoqueDisponivel} />
                </div>
                <div className="form-group form-group-sm os-materiais-field os-materiais-field--qtd">
                  <label className="label-gt">Quantidade</label>
                  <input
                    type="number"
                    step="0.001"
                    min="0.001"
                    className="form-control"
                    value={quantidade}
                    onChange={e => this.setState({ quantidade: e.target.value })}
                    placeholder="0"
                  />
                </div>
                <div className="form-group form-group-sm os-materiais-field os-materiais-field--obs">
                  <label className="label-gt">Observação</label>
                  <input
                    type="text"
                    className="form-control"
                    value={observacao}
                    onChange={e => this.setState({ observacao: e.target.value })}
                    placeholder="Opcional"
                  />
                </div>
                <div className="form-group form-group-sm os-materiais-field os-materiais-field--acao">
                  <label className="label-gt os-materiais-action-label" aria-hidden="true">
                    &nbsp;
                  </label>
                  <Button
                    type="button"
                    className="primary os-materiais-aplicar-btn"
                    icon="plus"
                    label="Aplicar"
                    onClick={this.adicionar}
                  />
                </div>
              </div>

              <div className="os-materiais-lista-header">
                <h5>
                  <i className="fa fa-clipboard-list" /> Itens aplicados
                  {!loading && materiais.length > 0 && (
                    <span className="os-materiais-lista-count">{materiais.length}</span>
                  )}
                </h5>
              </div>

              {loading ? (
                <div className="os-materiais-loading">
                  <i className="fa fa-spinner fa-spin" /> Carregando materiais...
                </div>
              ) : materiais.length === 0 ? (
                <div className="os-materiais-empty">
                  <div className="os-materiais-empty-icon">
                    <i className="fa fa-box-open" />
                  </div>
                  <strong>Nenhum material aplicado</strong>
                  <p>Selecione um item acima e clique em Aplicar para registrar a saída do estoque.</p>
                </div>
              ) : (
                <div className="os-materiais-lista">
                  {materiais.map(m => {
                    const qtdRestante = parseFloat(m.quantidade) - parseFloat(m.quantidade_devolvida || 0);
                    const qtdDevolvida = parseFloat(m.quantidade_devolvida || 0);
                    const dataAplicacao = m.data_aplicacao
                      ? new Date(m.data_aplicacao).toLocaleString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                          hour: '2-digit',
                          minute: '2-digit',
                        })
                      : '';

                    return (
                      <div className="os-material-item" key={m.id}>
                        <div className="os-material-item-header">
                          <div className="os-material-item-ident">
                            <div className="os-material-item-icon">
                              <i className="fa fa-cube" />
                            </div>
                            <div className="os-material-item-titulo-wrap">
                              <strong className="os-material-item-titulo">{m.item_descricao}</strong>
                              {m.observacao && (
                                <span className="os-material-item-obs">
                                  <i className="fa fa-comment-alt" /> {m.observacao}
                                </span>
                              )}
                            </div>
                          </div>
                          {dataAplicacao && (
                            <span className="os-material-item-data">
                              <i className="fa fa-clock" /> {dataAplicacao}
                            </span>
                          )}
                        </div>

                        <div className="os-material-item-stats">
                          <div className="os-material-stat os-material-stat--aplicado">
                            <span className="os-material-stat-label">Aplicado</span>
                            <span className="os-material-stat-value">
                              {m.quantidade} <small>{m.item_unidade}</small>
                            </span>
                          </div>
                          <div className="os-material-stat os-material-stat--devolvido">
                            <span className="os-material-stat-label">Devolvido</span>
                            <span className="os-material-stat-value">
                              {qtdDevolvida} <small>{m.item_unidade}</small>
                            </span>
                          </div>
                          <div
                            className={`os-material-stat os-material-stat--restante${
                              qtdRestante <= 0 ? ' is-zero' : ''
                            }`}
                          >
                            <span className="os-material-stat-label">Usado</span>
                            <span className="os-material-stat-value">
                              {qtdRestante} <small>{m.item_unidade}</small>
                            </span>
                          </div>
                        </div>

                        <div className="os-material-item-footer">
                          {qtdRestante > 0 ? (
                            <div className="os-material-devolver-form">
                              <label className="os-material-devolver-label" htmlFor={`devolver-${m.id}`}>
                                Devolver
                              </label>
                              <input
                                id={`devolver-${m.id}`}
                                type="number"
                                step="0.001"
                                min="0.001"
                                max={qtdRestante}
                                className="form-control os-material-devolver-input"
                                value={qtdDevolver[m.id] || ''}
                                onChange={e => this.alterarQtdDevolver(m.id, e.currentTarget.value)}
                                placeholder={`máx ${qtdRestante}`}
                              />
                            </div>
                          ) : (
                            <div className="os-material-totalmente-devolvido">
                              <i className="fa fa-check-circle" /> Totalmente devolvido
                            </div>
                          )}
                          <div className="os-materiais-actions-group">
                            {qtdRestante > 0 && (
                              <SPButton
                                type="button"
                                className="success btn-sm"
                                icon="undo"
                                data-title="Devolver"
                                onClick={() => this.devolverParcial(m)}
                                disabled={devolvendoId === m.id}
                              />
                            )}
                            <SPButton
                              type="button"
                              className="danger btn-sm"
                              icon="trash-alt"
                              data-title="Remover"
                              onClick={() => this.remover(m)}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  osId: state.manutencaoOS.selectedOS && state.manutencaoOS.selectedOS.id,
  osNumero: state.manutencaoOS.selectedOS && state.manutencaoOS.selectedOS.numero,
});

export default connect(mapStateToProps)(OrdemServicoMateriais);
